import { Component } from '@angular/core';

import { DateAdvancedFilterModel, ICellEditorParams, JoinAdvancedFilterModel } from 'ag-grid-enterprise';

import { DatePickerComponent } from '@camelot/form-input';

import { BaseEditorComponent } from '../base-col';
import type { DateCol } from './date-col';

@Component({
  host: { 'data-cid': 'date-editor' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [DatePickerComponent],
  template: `<cam-input-date-picker
    [input]="$any(this.input)"
    [standalone]="true"
    [onFocus]="this.focus$"
  ></cam-input-date-picker>`,
})
export class DateEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | DateAdvancedFilterModel,
  DateCol
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);
  }

  override isPopup(): boolean {
    return true;
  }

  getValue() {
    return this.input?.value ?? null;
  }
}
